import { defineStore } from "pinia";
import axios from "@/utils/adminApi";
export const useNotificationStore = defineStore("notification", {
  state: () => ({
    topups: [], // รายการขอเติมเงิน
    withdrawals: [], // รายการขอถอนเงิน
    loading: false,
    error: null,
  }),

  getters: {
    topupCount: (state) => state.topups.length,
    withdrawalCount: (state) => state.withdrawals.length,
    // ดึงเฉพาะ 5 รายการแรกมาแสดงใน Hover Popup
    latestTopups: (state) => state.topups.slice(0, 5),
    latestWithdrawals: (state) => state.withdrawals.slice(0, 5),
  },

  actions: {
    async fetchNotifications() {
      this.loading = true;
      try {
        // ยิง API พร้อมกัน 2 ตัวเพื่อความเร็ว
        const [topupRes, withdrawRes] = await Promise.all([
          axios.get("/api/admin/wallet/pending-topups"),
          axios.get("/api/admin/wallet/pending-withdrawals"),
        ]);

        this.topups = topupRes.data;
        this.withdrawals = withdrawRes.data;
      } catch (err) {
        console.error("Failed to fetch notifications:", err);
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
  },
});
